import { Link, useLocation } from "react-router";

import { cn } from "@/lib/utils";

const TABS = [
  { to: "/dinero", label: "Panel" },
  { to: "/dinero/beneficio", label: "Beneficio por cliente" },
  { to: "/dinero/contabilidad", label: "Contabilidad" },
  { to: "/dinero/setters", label: "Setters" },
  { to: "/dinero/comisiones", label: "Comisiones" },
];

/** Sub navigation of the money section. */
export const MoneyTabs = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex gap-1 rounded-lg bg-muted p-1 text-sm">
      {TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={cn(
            "rounded-md px-3 py-1.5 font-medium transition-colors",
            pathname === tab.to
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
};
